import React from 'react';
import myPic from '../Asset/IMG_20230612_212042_531.jpg'
import { MdKeyboardArrowRight } from "react-icons/md";
import {Link} from 'react-scroll'
const Home = () => {
  return (
    <div name="Home" 
     className='w-full h-screen  bg-gradient-to-b from-black via-black to-gray-800 '
    >
       <div className='max-w-screen-lg md:flex-row px-4 mx-auto flex flex-col items-center justify-center h-full'>
          <div className='flex justify-center flex-col h-full'>
             <h2 className='text-white text-4xl font-bold sm:text-7xl '>I'm a frontend Developer</h2>
             <p className='text-gray-500 py-4 max-w-md'>
                I am a learner and a developer . Currently I am working on web application using technologies like React , tailwind and Next Js
             </p>
             <div>
                <Link to='Portfolio' smooth duration={500} className= 'group text-white flex items-center px-6 py-3 my-3 w-fit rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer'>
                    Portfolio
                    <span className='group-hover:rotate-90 duration-300'>
                 <MdKeyboardArrowRight size={25} className='ml-1'/>
                    </span>
                </Link>
             </div>
          </div>
          <div>
            <img src={myPic} alt="my Profile" className='mx-auto rounded-2xl w-2/3 md:w-full'/>
          </div>
        </div>    
    </div>
  )
}

export default Home
